import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import e2eClasses from 'helpers/automation'

export const Separator = styled.div`
  width: 5%;

  ${mediaQueries.tablet`
    height: 35px;
  `};

  ${mediaQueries.mobile`
    height: 22px;
  `};
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 25px 0 0;
  ${({ noPadding }) =>
    noPadding &&
    `
      padding: 0;
    `};
`

export const Content = styled.div`
  display: none;
  flex-direction: column;
  padding: 0 10px;

  ${props =>
    props.isExpanded &&
    css`
      display: flex;
    `};
`

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 0 20px 0;
`

export const HeaderLabel = styled.div`
  display: flex;
`

export const HeaderText = styled.label`
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: 20px;
  padding: 0 0 0 10px;
`

export const Row = styled.div`
  display: flex;
  width: 100%;
  padding: 0 0 33px 0;

  ${mediaQueries.tablet`
    padding: 0 0 25px 0;
  `};

  ${mediaQueries.mobile`
    ${({ fixedMobile }) =>
      !fixedMobile &&
      `
       flex-direction: column;
       grid-template-columns: repeat(1, 1fr);
    `};
  `};
  ${({ noPadding }) =>
    noPadding &&
    `
    padding: 0;
  `};

  ${({ isMultidestiny }) =>
    isMultidestiny &&
    `
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      ${mediaQueries.mobile`
      grid-template-columns: repeat(1, 1fr);
      `};
  `};
`

export const Column = styled.div.attrs(props => ({
  className: props.e2eClass
}))`
  display: flex;

  ${props => (props.width ? `width: ${props.width}` : 'flex: 1')};
  ${props =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `};

  ${({ alignBottom }) =>
    alignBottom &&
    `
      align-items: flex-end;
  `};

  ${mediaQueries.mobile`
    ${({ fixedMobile }) =>
      !fixedMobile &&
      `
      flex-direction: column;
      width:100%;
    `};
  `};
`

export const InputWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export const Label = styled.label.attrs(props => ({
  className: props.e2eClass && `${e2eClasses('common.inputTitle')}${props.e2eClass}`
}))`
  color: ${({ theme }) => theme.colors.doveGray};
  padding: 15px 0;
  font-size: 1em;
  font-family: ${({ theme }) => theme.fonts.semiBold};
`

export const InputNumberLabel = styled(Label)`
  padding: 0 0 15px;
  font-size: 14px;
`

export const Line = styled.div`
  border-bottom: solid 1px ${({ theme }) => theme.colors.blue};

  && + div {
    padding: 32px 0 0;
  }
`

export const IsOnlyResponsive = styled.div`
  display: none;

  ${mediaQueries.mobile`
    display: ${({ isResponsive }) => (isResponsive ? 'block' : 'none')};
  `};
`
export const ButtonContainer = styled.div`
  align-self: center;
  width: 20%;
  padding: 16px;
`
